import IExtension from "./IExtension";
import {Naja} from "naja";

type TModalsIds = '*'|string|string[];

/**
 * @see app/model/services/ModalControllerService.php
 */
export default class CloseModalsExtension implements IExtension {
    initialize(naja: Naja): void {
        naja.addEventListener("complete", e => {
            const modalIds: TModalsIds = e.detail.payload?.closeModals || [];

            if (modalIds === '*') {
                this.closeAllModals();
            } else if (Array.isArray(modalIds) && modalIds.includes('*')) {
                this.closeAllModals();
            } else if (typeof modalIds === 'string') {
                this.closeModals([modalIds])
            } else if (Array.isArray(modalIds)) {
                this.closeModals(modalIds);
            } else {
                throw new Error(`Unable to close modals by ids '${modalIds}'.`);
            }

        });
    }

    private closeModals(modals: string[]) {
        modals.forEach(modalId => $('#' + modalId).modal('hide'));
    }

    private closeAllModals() {
        $('.modal.show').each((i, modal) => {
            $(modal).modal('hide');
        });

        $(document.body)
            .removeClass("modal-open")
            .css('overflow', '')
            .css('padding-right', '');
        $(".modal-backdrop").remove();
    }
}
